import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React, { useContext, Fragment } from 'react';
import classNames from 'classnames';
import { gql } from '@nerdwallet/apollo';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import MarketplaceCta from '@nerdwallet/react-marketplace-cta';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import { Type } from '@nerdwallet/currency';
import { getOfferId } from '@nerdwallet/marketplace/selectors/common';
import { KetoCompareCardCheckBox, CHECKBOX_STYLE } from '@nerdwallet/compare-credit-cards-bar';
import { getLegacyId } from '@nerdwallet/marketplace/selectors/credit-cards';
import { buildTrkSectionCategory, sanitizeNode, getMonetizable } from '../lib/utils';
import { TRK_PRODUCT_LOCATION } from '../lib/constants';
import styles from "./keto-product-card.module.css";
var BaseKetoProductCardHeader = function BaseKetoProductCardHeader(_ref) {
  var cta = _ref.cta,
    hasPreheader = _ref.hasPreheader,
    heading = _ref.heading,
    isPreheaderBadge = _ref.isPreheaderBadge,
    omitCta = _ref.omitCta,
    productCardPreheader = _ref.productCardPreheader;
  // using <Type> instead of <Title> since <Title> doesn't let us override the color
  var productCardHeading = /*#__PURE__*/React.createElement(Type, {
    bold: true,
    className: classNames([styles.ketoHeadingText, !hasPreheader && styles.ketoHeadingTextPadding]),
    color: "neutral-darkest",
    component: "h3",
    chronicle: false,
    gotham: false,
    size: 3,
    uppercase: false,
    italic: false,
    light: false
  }, sanitizeNode(heading));
  return /*#__PURE__*/React.createElement(Fragment, null, hasPreheader ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.ketoPreheaderContainer, !isPreheaderBadge && styles.preHeaderTopMargin, isPreheaderBadge && styles.preheaderContainerBadge])
  }, productCardPreheader) : null, /*#__PURE__*/React.createElement("div", {
    className: styles.heading
  }, omitCta ? productCardHeading : cta));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  BaseKetoProductCardHeader.propTypes = {
    cta: PropTypes.node,
    hasPreheader: PropTypes.bool,
    heading: PropTypes.node.isRequired,
    isPreheaderBadge: PropTypes.bool,
    omitCta: PropTypes.bool,
    productCardPreheader: PropTypes.node
  };
}
export var GraphQLKetoProductCardHeader = function GraphQLKetoProductCardHeader(_ref2) {
  var className = _ref2.className,
    checkboxLabel = _ref2.checkboxLabel,
    handleCompare = _ref2.handleCompare,
    hasCompareButton = _ref2.hasCompareButton,
    hasPreheader = _ref2.hasPreheader,
    isPreheaderBadge = _ref2.isPreheaderBadge,
    isSelectedToCompare = _ref2.isSelectedToCompare,
    marketplaceEntity = _ref2.marketplaceEntity,
    legacyTrkProps = _ref2.legacyTrkProps,
    omitCta = _ref2.omitCta,
    productCardPreheader = _ref2.productCardPreheader,
    reviewLinkOverride = _ref2.reviewLinkOverride,
    addToFavoritesNode = _ref2.addToFavoritesNode,
    trackNonMonetizingSegmentShoppingFinished = _ref2.trackNonMonetizingSegmentShoppingFinished;
  var impressionContext = useContext(ImpressionContext);
  var displayName = marketplaceEntity.displayName;
  var cta = /*#__PURE__*/React.createElement(MarketplaceCta, {
    analyticsPayloadOverrides: {
      product_impression_id: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId
    },
    className: styles.headingLink,
    gqlMarketplaceEntity: marketplaceEntity,
    omitImpression: true,
    linkType: APPLY_NOW_LINK_TYPES.productName,
    id: "".concat(TRK_PRODUCT_LOCATION, "__product-name-").concat(legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkProductPosition),
    legacyTrkProps: legacyTrkProps,
    reviewLinkOverride: reviewLinkOverride,
    trackNonMonetizingSegmentShoppingFinished: trackNonMonetizingSegmentShoppingFinished
  }, /*#__PURE__*/React.createElement(Type, {
    bold: true,
    className: classNames([styles.ketoHeadingText, !hasPreheader && styles.ketoHeadingTextPadding]),
    color: "neutral-darkest",
    component: "h3",
    chronicle: false,
    gotham: false,
    size: 3,
    uppercase: false,
    italic: false,
    light: false
  }, displayName));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(BaseKetoProductCardHeader, {
    cta: cta,
    hasPreheader: hasPreheader,
    heading: displayName,
    isPreheaderBadge: isPreheaderBadge,
    omitCta: omitCta,
    productCardPreheader: productCardPreheader
  }), addToFavoritesNode, hasCompareButton && !addToFavoritesNode ? [/*#__PURE__*/React.createElement("div", {
    className: classNames([styles.compareBtnDesktop, isPreheaderBadge && styles.compareTopMargin]),
    key: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.compareCheckbox
  }, /*#__PURE__*/React.createElement(KetoCompareCardCheckBox, {
    card: {
      id: marketplaceEntity === null || marketplaceEntity === void 0 ? void 0 : marketplaceEntity.legacyId,
      offerId: marketplaceEntity === null || marketplaceEntity === void 0 ? void 0 : marketplaceEntity.id
    },
    analytics: {
      enabled: true
    },
    showCheckboxLabel: true,
    checkboxLabel: checkboxLabel,
    handleCompare: handleCompare,
    isSelectedToCompare: isSelectedToCompare
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.compareBtnMobile, isPreheaderBadge && styles.compareTopMargin]),
    key: "1"
  }, /*#__PURE__*/React.createElement(KetoCompareCardCheckBox, {
    card: {
      id: marketplaceEntity === null || marketplaceEntity === void 0 ? void 0 : marketplaceEntity.legacyId,
      offerId: marketplaceEntity === null || marketplaceEntity === void 0 ? void 0 : marketplaceEntity.id
    },
    analytics: {
      enabled: true
    },
    showCheckboxLabel: false,
    handleCompare: handleCompare,
    elementStyle: CHECKBOX_STYLE.BUTTON,
    isSelectedToCompare: isSelectedToCompare
  }))] : null);
};
GraphQLKetoProductCardHeader.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment GraphQLKetoProductCardHeader on MarketplaceEntityInterface {\n    ... on CreditCardsOfferV2 {\n      id\n      legacyId\n    }\n    ... on MarketplaceEntityWithPlacementInterface {\n      displayName\n    }\n    ...MarketplaceCta\n  }\n  ", "\n"])), MarketplaceCta.fragment);
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes = require('prop-types');
  GraphQLKetoProductCardHeader.propTypes = {
    className: _PropTypes.string,
    checkboxLabel: _PropTypes.string,
    handleCompare: _PropTypes.func,
    hasCompareButton: _PropTypes.bool,
    hasPreheader: _PropTypes.bool,
    isPreheaderBadge: _PropTypes.bool,
    isSelectedToCompare: _PropTypes.bool,
    addToFavoritesNode: _PropTypes.node,
    // TODO (RUR-246): The following props can be removed once we cutover to Bedrock
    legacyTrkProps: _PropTypes.shape({
      trkElement: _PropTypes.string,
      trkLocation: _PropTypes.string,
      trkPageType: _PropTypes.string,
      trkProductPosition: _PropTypes.number,
      trkSectionCategory: _PropTypes.string,
      trkTaxonomy: _PropTypes.shape({
        contentType: _PropTypes.string,
        pageType: _PropTypes.string,
        topic: _PropTypes.string,
        vertical: _PropTypes.string
      })
    }),
    marketplaceEntity: _PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    omitCta: _PropTypes.bool,
    productCardPreheader: _PropTypes.node,
    reviewLinkOverride: _PropTypes.string,
    trackNonMonetizingSegmentShoppingFinished: _PropTypes.func
  };
}
var KetoProductCardHeader = function KetoProductCardHeader(_ref3) {
  var className = _ref3.className,
    heading = _ref3.heading,
    marketplaceEntity = _ref3.marketplaceEntity,
    _hasCcCompareButton = _ref3._hasCcCompareButton,
    _handleCcCompareClick = _ref3._handleCcCompareClick,
    checkboxLabel = _ref3.checkboxLabel,
    enableAnalytics = _ref3.enableAnalytics,
    reviewLinkHref = _ref3.reviewLinkHref,
    shouldLogImpression = _ref3.shouldLogImpression,
    taxonomy = _ref3.taxonomy,
    trkPageType = _ref3.trkPageType,
    trkProductPosition = _ref3.trkProductPosition,
    trkSectionCategory = _ref3.trkSectionCategory,
    ctaHref = _ref3.ctaHref,
    displayPage = _ref3.displayPage,
    omitCta = _ref3.omitCta,
    productCardPreheader = _ref3.productCardPreheader,
    isPreheaderBadge = _ref3.isPreheaderBadge,
    hasPreheader = _ref3.hasPreheader,
    isSelectedToCompare = _ref3.isSelectedToCompare;
  var impressionContext = useContext(ImpressionContext);
  // using Type instead of Title since Title doesn't allow overriding the color.
  var productCardHeading = /*#__PURE__*/React.createElement(Type, {
    bold: true,
    className: classNames([styles.ketoHeadingText, !hasPreheader && styles.ketoHeadingTextPadding]),
    color: "neutral-darkest",
    component: "h3",
    chronicle: false,
    gotham: false,
    size: 3,
    uppercase: false,
    italic: false,
    light: false
  }, sanitizeNode(heading));
  var cta = /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    className: styles.headingLink,
    id: "".concat(TRK_PRODUCT_LOCATION, "__product-name-").concat(trkProductPosition),
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: APPLY_NOW_LINK_TYPES.productName,
    monetizable: getMonetizable(marketplaceEntity),
    marketplaceEntity: marketplaceEntity,
    productLocation: TRK_PRODUCT_LOCATION,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    shouldLogImpression: shouldLogImpression,
    trkPageType: trkPageType,
    trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'productName'),
    trkTaxonomy: taxonomy,
    type: LINK_TYPES.LINK
    // BNK specific props.
    ,
    displayPage: displayPage,
    disableBankCtaAnnotation: true
  }, productCardHeading);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(BaseKetoProductCardHeader, {
    cta: cta,
    hasPreheader: hasPreheader,
    heading: heading,
    isPreheaderBadge: isPreheaderBadge,
    omitCta: omitCta,
    productCardPreheader: productCardPreheader
  }), _hasCcCompareButton ? [/*#__PURE__*/React.createElement("div", {
    className: classNames([styles.compareBtnDesktop, isPreheaderBadge && styles.compareTopMargin]),
    key: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.compareCheckbox
  }, /*#__PURE__*/React.createElement(KetoCompareCardCheckBox, {
    card: {
      id: getLegacyId(marketplaceEntity),
      offerId: getOfferId(marketplaceEntity)
    },
    analytics: {
      enabled: enableAnalytics
    },
    showCheckboxLabel: true,
    checkboxLabel: checkboxLabel,
    handleCompare: _handleCcCompareClick,
    isSelectedToCompare: isSelectedToCompare
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.compareBtnMobile, isPreheaderBadge && styles.compareTopMargin]),
    key: "1"
  }, /*#__PURE__*/React.createElement(KetoCompareCardCheckBox, {
    card: {
      id: getLegacyId(marketplaceEntity),
      offerId: getOfferId(marketplaceEntity)
    },
    analytics: {
      enabled: enableAnalytics
    },
    showCheckboxLabel: false,
    handleCompare: _handleCcCompareClick,
    elementStyle: CHECKBOX_STYLE.BUTTON,
    isSelectedToCompare: isSelectedToCompare
  }))] : null);
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes2 = require('prop-types');
  KetoProductCardHeader.propTypes = {
    className: _PropTypes2.string,
    heading: _PropTypes2.node.isRequired,
    marketplaceEntity: _PropTypes2.object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    _hasCcCompareButton: _PropTypes2.bool,
    _handleCcCompareClick: _PropTypes2.func,
    checkboxLabel: _PropTypes2.string,
    omitCta: _PropTypes2.bool,
    reviewLinkHref: _PropTypes2.string,
    shouldLogImpression: _PropTypes2.bool,
    taxonomy: _PropTypes2.object,
    // eslint-disable-line react/forbid-prop-types
    trkPageType: _PropTypes2.string,
    trkProductPosition: _PropTypes2.number,
    trkSectionCategory: _PropTypes2.string,
    isSelectedToCompare: _PropTypes2.bool,
    // BNK specific props.
    displayPage: _PropTypes2.string,
    ctaHref: _PropTypes2.string,
    productCardPreheader: _PropTypes2.node,
    isPreheaderBadge: _PropTypes2.bool,
    hasPreheader: _PropTypes2.bool,
    // bedrock instrumentation props
    // A flag to indicate if analytics is being sent.
    enableAnalytics: _PropTypes2.bool
  };
}
export default KetoProductCardHeader;